<template>
  <multiselect
    v-model="selection"
    :class="[{'spl-multiselect--invalid': invalid}, {'spl-multiselect--limitheight': limitHeight}, 'spl-multiselect']"
    :options="options"
    :multiple="true"
    :close-on-select="false"
    :clear-on-select="true"
    :hide-selected="hideSelected"
    :placeholder="placeholder"
    :disabled="disabled"
    :track-by="trackBy"
    :show-labels="false"
    :open-direction="$mq === 'sm' ? 'above' : 'auto'"
    :max-height="$mq === 'sm' ? 120 : 300"
    class="spl-multiselect"
    :label="label"
    @input="onChange" />
</template>

<script>
import Multiselect from 'vue-multiselect'
import { map, filter, difference } from 'lodash'

export default {
  components: { Multiselect },
  props: {
    options: {
      type: Array,
      default: () => {
        return []
      }
    },
    limitHeight: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'label'
    },
    trackBy: {
      type: String,
      default: 'value'
    },
    value: {
      type: Array,
      default: () => {
        return []
      }
    },
    hideSelected: {
      type: Boolean,
      default: true
    },
    invalid: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selection: []
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      var foundOptions = filter(this.options, option => {
        return newVal.indexOf(option[this.trackBy]) > -1
      })
      if (
        foundOptions.length !== this.options.length ||
        difference(foundOptions, this.options).length > 0
      ) {
        this.selection = foundOptions
      }
    },
    options: {
      handler: function () {
        this.selection = filter(this.options, option => {
          return this.value.indexOf(option[this.trackBy]) > -1
        })
      },
      deep: true
    }
  },
  mounted () {
    if (this.value) {
      this.selection = filter(this.options, option => {
        return this.value.indexOf(option[this.trackBy]) > -1
      })
    }
  },
  methods: {
    onChange (newVal) {
      this.selection = newVal
      this.$emit('valuesSelected', map(newVal, this.trackBy))
      this.$emit('input', map(newVal, this.trackBy))
    },
    reset () {
      this.selection = []
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

<style lang="scss">
@import "../../variables.scss";
.spl-multiselect {
  &--invalid .multiselect__tags,
  &--invalid .multiselect__input {
    background-color: $redBackgroundLight;
    border-color: $errorRed;
  }

  &--limitheight {
    .multiselect__tags {
      max-height: 40px;
      overflow: hidden;
    }
  }
  .multiselect__option--highlight {
    background: $middleYellow;
    color: black;
  }

  .multiselect__option--highlight:after {
    content: attr(data-select);
    background: $middleYellow;
    color: black;
  }

  .multiselect__tag {
    position: relative;
    display: inline-block;
    padding: 4px 26px 4px 10px;
    border-radius: 5px;
    margin-right: 10px;
    color: black;
    line-height: 1;
    background: $middleYellow;
    margin-bottom: 5px;
    white-space: nowrap;
    overflow: hidden;
    max-width: 100%;
    text-overflow: ellipsis;
  }

  .multiselect__tag-icon:after {
    content: "×";
    color: black;
    font-size: 14px;
  }

  .multiselect__tag-icon:focus,
  .multiselect__tag-icon:hover {
    background: $darkerYellow;
  }
}
</style>
